import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import ReportDetails from "./ReportDetails";
import ReportTab from "./ReportTab";

const Conscientiousness = (props: any) => {
    const scoreDescription = {
        High: ["Organized", "Disciplined", "Goal-Oriented", "Ambitious", "Thorough"],
        Moderate: ["Prefers structure", "Can be flexible", "Moderately organized", "Seeks balance in life", "Relaxed"],
        Low: ["Spontaneous", "Flexible", "Multitasker", "Haphazard", "Impulsive"],
    };
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row between-xs middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id={"title-page-" + props.name} tabIndex={-1}>
                        RepIQ™ Reputation Analyzer Report
                    </h1>
                </div>
            </div>

            <ReportTab selectedTab="2" />

            <div className="row" id="content">
                <div className="col-xs-12">
                    <div className="box">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Conscientiousness</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <p>
                                        Conscientiousness measures the degree of someone's focus and drive to achieve goals. It is based on traits related to order,
                                        persistence, and impulse control. People who score high in Conscientiousness are often skilled planners and problem-solvers.
                                        They are able to focus their attention on the task at hand and follow through with long-term goals. Individuals with high
                                        Conscientiousness scores are often sought by employers, as this metric is a reliable predictor of successful workplace
                                        performance.
                                    </p>
                                    <p>
                                        People who score low in Conscientiousness tend to be go-with-the-flow types. They're more laid back, less organized, and may
                                        be easily distracted.
                                    </p>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <div role="option" className="img-container">
                                        <img src="images/img-conscientiousness.jpg" alt="Person working on a laptop checking off a to-do list" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReportDetails title={"Conscientiousness"} name={"Conscientiousness"} scoreDescription={scoreDescription} />
                </div>
            </div>
        </React.Fragment>
    );
};
export default Conscientiousness;
